import { Lit3formBlock, html } from '@Root/lib/lit-3form-block';
import { styles } from './css';
import { analyticsCtaDataObject } from '../../../helpers/adobe-analytics';

export class Ignacio extends Lit3formBlock {
  static get characterName() {
    return 'ignacio';
  }

  static get characterStyles() {
    return [...styles];
  }

  render() {
    return html`
      <div class="block-wrapper">
        <div class="block-grid ignacio-layout">
          ${this.introHTML} ${this.cardsHTML} ${this.horizontalRule}
        </div>
      </div>
    `;
  }

  get introHTML() {
    if (!this.headerText && !this.descriptionText && !this.ctaData) {
      return html``;
    }
    return html`
      <block-intro
        class="intro"
        header=${this.content.header || ''}
        description=${this.content.description || ''}
      >
        ${this.ctaHTML}
      </block-intro>
    `;
  }

  get ctaHTML() {
    const cta = this.ctaData;
    if (!cta || !cta.text) return html``;
    return html`
      <cta-text
        class="learn-more"
        cta-data=${JSON.stringify(cta)}
        .ctaAnalyticsData=${analyticsCtaDataObject(cta, this.headerText)}
      ></cta-text>
    `;
  }

  get ctaData() {
    return this.content.call_to_action;
  }

  get cardsHTML() {
    if (!this.imagesArr.length) return html``;
    return html`
      <div class="cards">
        ${this.imagesArr.map(i => this.cardHTML(i[1]))}
      </div>
    `;
  }

  // Widest card is 212px at the 1440px block cap, so 440 covers it at 2x.
  // Height is left off deliberately: ImageBoss then scales to width and the
  // image keeps its own aspect ratio.
  cardHTML(card) {
    return html`
      <driver-card
        class="card"
        .card=${card}
        placement=${this.analyticsBlockLabel}
        download-placement=${this.headerText}
        image-width="440"
      >
        ${this.cardCtaHTML(card)}
      </driver-card>
    `;
  }

  // The card's own "CTA Text" + URL pair as a text link, the way clark and
  // elle render it. Not in the design, so it only shows once an editor fills
  // the pair in.
  cardCtaHTML(card) {
    if (!card.text) return html``;
    return html`
      <cta-text
        class="card-cta"
        cta-data=${JSON.stringify({
          text: card.text,
          url: card.url,
        })}
        .ctaAnalyticsData=${analyticsCtaDataObject(card, this.headerText)}
      ></cta-text>
    `;
  }
}
Ignacio.defineElement();
